// React
import React from 'react'

// Packages
import { grey } from '@mui/material/colors';
import { Typography } from '@mui/material';

const Packages = () => {
  return (
    <div style={{ backgroundColor: grey[200], height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Typography variant="h3" gutterBottom>Paquetes</Typography>
    </div>
  )
}

export default Packages
